import classNames from 'classnames';
import { KeywordNode, KeywordNodes } from 'components/discover/publications/video-browser/model';
import { FC } from 'react';

type KeywordListProps = Readonly<{
  activeKeyword: KeywordNode | null;
  keywords: KeywordNodes;
  onSelect: (keyword: KeywordNode) => void;
}>;

export const KeywordList: FC<KeywordListProps> = ({ keywords, activeKeyword, onSelect }) => {
  if (keywords.length < 1) {
    return null;
  }
  return (
    <nav className="nav nav-vertical nav-underline nav-hover">
      {keywords.map(keyword => {
        const isActive = keyword.id === activeKeyword?.id;
        return (
          <button
            type="button"
            key={keyword.id}
            className={classNames('nav-link text-truncate w-100 text-start', {
              active: isActive,
              'text-info': isActive,
            })}
            title={keyword.name}
            onClick={() => onSelect(keyword)}
            role="menuitem"
            name={keyword.name}
          >
            {keyword.name}
          </button>
        );
      })}
    </nav>
  );
};
